module.exports = __webpack_public_path__ + "media/icons/map-icon-rectangle-b90c6094.svg";